<template>
    <div class="fondo">
        <v-container style="margin: 0 auto ; max-width: 65rem; width: 100%;">
            <v-form ref="form" v-model="valid" @submit.prevent="submitForm">
                <div>
                    <v-card class="mb-4 card-titulo" style="color: #0F57AC;padding: 1.9rem;">
                            <h1 class="titulo-from">
                                CONTROL MICROBIOLÓGICO DE AGUAS PARA DIÁLISIS
                            </h1>
                    </v-card>
                    <el-form :model="encuestaForm" label-position="top" :rules="rules" ref="encuestaForm">
                        <v-card class="mb-4">
                            <h3 style="margin-bottom: 1rem;">INFORME DE MICROBIOLOGÍA</h3>
                            <v-row>
                                <v-col cols="12" lg="4" md="6">
                                    <el-form-item label="Método" :label-width="formLabelWidth" prop="metodo">
                                        <el-input v-model="encuestaForm.metodo" autocomplete="off" disabled></el-input>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="4" md="6">
                                    <el-form-item label="Fecha de muestreo" :label-width="formLabelWidth" prop="fecha_muestreo">
                                        <el-date-picker style="width: 100%;" v-model="encuestaForm.fecha_muestreo"
                                            type="date" placeholder="Fecha de Muestreo" :editable=false>
                                        </el-date-picker>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="4" md="6">
                                    <el-form-item label="IPRESS" :label-width="formLabelWidth" prop="ipress">
                                        <el-select v-model="encuestaForm.ipress" filterable placeholder="IPRESS"
                                            disabled style="width: 100%;">
                                            <el-option v-for="item in arrayClinica" :key="item.value"
                                                :label="item.descripCas" :value="item.id_cas">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-card class="mb-4">
                            <h3>SALIDA DE ÓSMOSIS (RODI)</h3>
                            <v-divider class="my-4"></v-divider>
                            <h5 style="margin-top: .5rem;font-size: .9rem;"> VALORES REFERENCIALES : </h5>
                            <div style="display: flex;align-items: center;margin-bottom: 1.4rem;font-size: .9rem;"><span> Agua Ultrapura
                                    : Heterótrofos totales : </span>
                                <el-select v-model="encuestaForm.val_osmosis_hete_total" style="margin: 0 .4rem;"
                                    size="mini">
                                    <el-option v-for="item in arrayHeterotrofos" :key="item" :label="item"
                                        :value="item">
                                    </el-option>
                                </el-select>
                            </div>
                            <v-divider class="my-4"></v-divider>
                            <h5 style="margin-top: .5rem;"> RESULTADOS : </h5>
                            <v-row style="margin-top: .1rem;">
                                <v-col cols="12" lg="6" md="6">
                                    <el-form-item label="Heterótrofos" :label-width="formLabelWidth"
                                        prop="osmosis_val_ref" size="medium">
                                        <el-input v-model="encuestaForm.hetero_osmosis" autocomplete="off"><template
                                                #suffix>UFC/100ml</template></el-input>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="6" md="6">
                                    <el-form-item label="Pseudomonas" :label-width="formLabelWidth"
                                        prop="osmosis_hete_total" size="medium">
                                        <el-input v-model="encuestaForm.pseudomonas_osmosis" autocomplete="off"><template
                                                #suffix>UFC/ml</template></el-input>
                                    </el-form-item>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-card class="mb-4">
                            <h3>SALIDA DE 2DO. MICROFILTRO</h3>
                            <v-divider class="my-4"></v-divider>
                            <h5 style="margin-top: .5rem;font-size: .9rem;"> VALORES REFERENCIALES : </h5>
                            <div style="display: flex;align-items: center;margin-bottom: 1.4rem;font-size: .9rem;"><span> Agua Purificada
                                    : Heterótrofos totales : </span>
                                <el-select v-model="encuestaForm.val_microfiltro_total" style="margin: 0 .4rem;"
                                    size="mini">
                                    <el-option v-for="item in arrayHeterotrofos" :key="item" :label="item"
                                        :value="item">
                                    </el-option>
                                </el-select>
                            </div>
                            <v-divider class="my-4"></v-divider>
                            <h5 style="margin-top: .5rem;"> RESULTADOS : </h5>
                            <v-row style="margin-top: .1rem;">
                                <v-col cols="12" lg="6" md="6">
                                    <el-form-item label="Heterótrofos" :label-width="formLabelWidth"
                                        prop="hetero_microfolito">
                                        <el-input v-model="encuestaForm.hetero_microfolito" autocomplete="off"><template
                                                #suffix>UFC/100ml</template></el-input>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="6" md="6">
                                    <el-form-item label="Pseudomonas" :label-width="formLabelWidth"
                                        prop="pseudomonas_microfiltro">
                                        <el-input v-model="encuestaForm.pseudomonas_microfiltro" autocomplete="off"><template
                                                #suffix>UFC/ml</template></el-input>
                                    </el-form-item>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-card class="mb-4">
                            <h3>ROTORNO DE ANILLO DE CIRCULACION</h3>
                            <v-divider class="my-4"></v-divider>
                            <h5 style="margin-top: .5rem;font-size: .9rem;"> VALORES REFERENCIALES : </h5>
                            <div style="display: flex;align-items: center;margin-bottom: 1.4rem;font-size: .9rem;"><span> Agua Purificada
                                    : Heterótrofos totales : </span>
                                <el-select v-model="encuestaForm.anillo_hete_total" style="margin: 0 .4rem;"
                                    size="mini">
                                    <el-option v-for="item in arrayHeterotrofos" :key="item" :label="item"
                                        :value="item">
                                    </el-option>
                                </el-select>
                            </div>
                            <v-divider class="my-4"></v-divider>
                            <h5 style="margin-top: .5rem;"> RESULTADOS : </h5>
                            <v-row style="margin-top: .1rem;">
                                <v-col cols="12" lg="6" md="6">
                                    <el-form-item label="Heterótrofos" :label-width="formLabelWidth"
                                        prop="hetero_anillo" size="medium">
                                        <el-input v-model="encuestaForm.hetero_anillo" autocomplete="off"><template
                                                #suffix>UFC/100ml</template></el-input>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="6" md="6">
                                    <el-form-item label="Pseudomonas" :label-width="formLabelWidth"
                                        prop="pseudomonas_ani_circulacion" size="medium">
                                        <el-input v-model="encuestaForm.pseudomonas_ani_circulacion" autocomplete="off"><template
                                                #suffix>UFC/ml</template></el-input>
                                    </el-form-item>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-card class="mb-4">
                            <h3>PUNTO DE DIALISIS SALA 1</h3>
                            <v-divider class="my-4"></v-divider>
                            <h5 style="margin-top: .5rem;font-size: .9rem;"> VALORES REFERENCIALES : </h5>
                            <div style="display: flex;align-items: center;margin-bottom: 1.4rem;font-size: .9rem;"><span> Solución de Dializado
                                    : Heterótrofos totales : </span>
                                <el-select v-model="encuestaForm.hetero_total_sala1" style="margin: 0 .4rem;"
                                    size="mini">
                                    <el-option v-for="item in arrayHeterotrofos" :key="item" :label="item"
                                        :value="item">
                                    </el-option>
                                </el-select>
                            </div>
                            <v-divider class="my-4"></v-divider>
                            <h5 style="margin-top: .5rem;"> RESULTADOS : </h5>
                            <v-row style="margin-top: .1rem;">
                                <v-col cols="12" lg="6" md="6">
                                    <el-form-item label="Heterótrofos" :label-width="formLabelWidth"
                                        prop="hetero_sala1" size="medium">
                                        <el-input v-model="encuestaForm.hetero_sala1" autocomplete="off"><template
                                                #suffix>UFC/100ml</template></el-input>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="6" md="6">
                                    <el-form-item label="Pseudomonas" :label-width="formLabelWidth"
                                        prop="pseudomonas_sala1" size="medium">
                                        <el-input v-model="encuestaForm.pseudomonas_sala1" autocomplete="off"><template
                                                #suffix>UFC/ml</template></el-input>
                                    </el-form-item>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-card class="mb-4">
                            <h3>PUNTO DE DIALISIS SALA 2</h3>
                            <v-divider class="my-4"></v-divider>
                            <h5 style="margin-top: .5rem;font-size: .9rem;"> VALORES REFERENCIALES : </h5>
                            <div style="display: flex;align-items: center;margin-bottom: 1.4rem;font-size: .9rem;"><span> Solución de Dializado
                                    : Heterótrofos totales : </span>
                                <el-select v-model="encuestaForm.hetero_total_sala2" style="margin: 0 .4rem;"
                                    size="mini">
                                    <el-option v-for="item in arrayHeterotrofos" :key="item" :label="item"
                                        :value="item">
                                    </el-option>
                                </el-select>
                            </div>
                            <v-divider class="my-4"></v-divider>
                            <h5 style="margin-top: .5rem;"> RESULTADOS : </h5>
                            <v-row style="margin-top: .1rem;">
                                <v-col cols="12" lg="6" md="6">
                                    <el-form-item label="Heterótrofos" :label-width="formLabelWidth"
                                        prop="hetero_sala2" size="medium">
                                        <el-input v-model="encuestaForm.hetero_sala2" autocomplete="off"><template
                                                #suffix>UFC/100ml</template></el-input>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="6" md="6">
                                    <el-form-item label="Pseudomonas" :label-width="formLabelWidth"
                                        prop="pseudomonas_sala2" size="medium">
                                        <el-input v-model="encuestaForm.pseudomonas_sala2" autocomplete="off"><template
                                                #suffix>UFC/ml</template></el-input>
                                    </el-form-item>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-card class="mb-4">
                            <h3>PUNTO DE DIALISIS SALA 3</h3>
                            <v-divider class="my-4"></v-divider>
                            <h5 style="margin-top: .5rem;font-size: .9rem;"> VALORES REFERENCIALES : </h5>
                            <div style="display: flex;align-items: center;margin-bottom: 1.4rem;font-size: .9rem;"><span> Solución de Dializado
                                    : Heterótrofos totales : </span>
                                <el-select v-model="encuestaForm.hetero_total_sala3" style="margin: 0 .4rem;"
                                    size="mini">
                                    <el-option v-for="item in arrayHeterotrofos" :key="item" :label="item"
                                        :value="item">
                                    </el-option>
                                </el-select>
                            </div>
                            <v-divider class="my-4"></v-divider>
                            <h5 style="margin-top: .5rem;"> RESULTADOS : </h5>
                            <v-row style="margin-top: .1rem;">
                                <v-col cols="12" lg="6" md="6">
                                    <el-form-item label="Heterótrofos" :label-width="formLabelWidth"
                                        prop="hetero_sala3" size="medium">
                                        <el-input v-model="encuestaForm.hetero_sala3" autocomplete="off"><template
                                                #suffix>UFC/100ml</template></el-input>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="6" md="6">
                                    <el-form-item label="Pseudomonas" :label-width="formLabelWidth"
                                        prop="pseudomonas_sala3" size="medium">
                                        <el-input v-model="encuestaForm.pseudomonas_sala3" autocomplete="off"><template
                                                #suffix>UFC/ml</template></el-input>
                                    </el-form-item>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-card class="mb-4">
                            <h3>PUNTO DE DIALISIS SALA 4</h3>
                            <v-divider class="my-4"></v-divider>
                            <h5 style="margin-top: .5rem;font-size: .9rem;"> VALORES REFERENCIALES : </h5>
                            <div style="display: flex;align-items: center;margin-bottom: 1.4rem;font-size: .9rem;"><span> Solución de Dializado
                                    : Heterótrofos totales : </span>
                                <el-select v-model="encuestaForm.hetero_total_sala4" style="margin: 0 .4rem;"
                                    size="mini">
                                    <el-option v-for="item in arrayHeterotrofos" :key="item" :label="item"
                                        :value="item">
                                    </el-option>
                                </el-select>
                            </div>
                            <v-divider class="my-4"></v-divider>
                            <h5 style="margin-top: .5rem;"> RESULTADOS : </h5>
                            <v-row style="margin-top: .1rem;">
                                <v-col cols="12" lg="6" md="6">
                                    <el-form-item label="Heterótrofos" :label-width="formLabelWidth"
                                        prop="hetero_sala4" size="medium">
                                        <el-input v-model="encuestaForm.hetero_sala4" autocomplete="off"><template
                                                #suffix>UFC/100ml</template></el-input>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="6" md="6">
                                    <el-form-item label="Pseudomonas" :label-width="formLabelWidth"
                                        prop="pseudomonas_sala4" size="medium">
                                        <el-input v-model="encuestaForm.pseudomonas_sala4" autocomplete="off"><template
                                                #suffix>UFC/ml</template></el-input>
                                    </el-form-item>
                                </v-col>
                            </v-row>
                        </v-card>
                    </el-form>
                </div>
                <v-btn color="primary" type="submit">Enviar</v-btn>
            </v-form>
        </v-container>
    </div>
</template>
<script>
import Swal from 'sweetalert2';
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
export default {
    data() {
        return {
            arrayHeterotrofos: [
                '< 0.1 UFC/ml',
                '< 100 UFC/ml'
            ],
            arrayClinica: [],
            formLabelWidth: "15px",
            encuestaForm: {
                metodo: "Filtración por membrana",
                ipress: 1,
                codigo: "DAT.MA.FO.01.06",
                version: "1",
                fecha: "12/12/2022",
                fecha_muestreo: null,

                val_osmosis_hete_total:null,
                hetero_osmosis: null,
                pseudomonas_osmosis: null,

                val_microfiltro_total: null,
                hetero_microfolito: null,
                pseudomonas_microfiltro: null,

                anillo_hete_total: null,
                hetero_anillo: null,
                pseudomonas_ani_circulacion: null,

                hetero_total_sala1: null,
                hetero_sala1: null,
                pseudomonas_sala1: null,

                
                hetero_total_sala2: null,
                hetero_sala2: null,
                pseudomonas_sala2: null,

                hetero_total_sala3: null,
                hetero_sala3: null,
                pseudomonas_sala3: null,

                hetero_total_sala4: null,
                hetero_sala4: null,
                pseudomonas_sala4: null,
            },
            selectedSection: 'Su salud',
            valid: false,
            formData: {},
            rules: {
                required: v => !!v || "Este campo es obligatorio",
            },
            opcionesTabla1: ["Ninguna", "Leve", "Moderada", "Severa", "Extrema o no puede hacerlo"],
            opciones: ["Derecha", "Izquierda", "No Aplica"],
            respuestas: Array(12).fill("")
        };
    },
    created() {
        this.loadIpress();
    },
    methods: {
        loadIpress() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/generar_lista_ipress/", { "tipoCas": 2 }, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.arrayClinica = res.data;
                        })
                        .catch((res) => {
                            /* this.dialog = false; */
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        submitForm() {
            if (this.$refs.form.validate()) {
                console.log("Respuestas:", this.encuestaForm);
            }
        },
    },
};
</script>

<style scoped>
/* Para tablets */
@media (max-width: 768px) {
  .titulo-from {
    font-size: 28px;
  }
}

/* Para celulares */
@media (max-width: 480px) {
    .card-titulo{
        padding: 1.4rem !important;
    }
  .titulo-from {
    font-size: 23px;
    line-height: 1.8rem;
  }
}
::v-deep .el-form-item__label {
    line-height: 0px !important;
}

.v-card {
    padding: 2rem;
    border-radius: 12px;
    background:
        linear-gradient(180deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 15%, rgb(255, 255, 255) 100%)
}

.fondo {
    background: url(https://cdn.forms.office.net/images/aio/wave-pattern-v1.svg) center top / cover no-repeat, linear-gradient(180deg, #0F57AC 0%, rgba(3, 98, 206, 0.935) 100%);
    background-attachment: fixed;
    /* Fija el fondo al hacer scroll */
}
</style>